import { MetricsV1MeasurementInput } from '@spotify/confidence-graphql';

import { MeasurementFormValues } from './types';

export function toMeasurementInput(
  values: Omit<MeasurementFormValues, 'metricType'>,
): MetricsV1MeasurementInput {
  return {
    displayName: values.displayName,
    description: values.description ?? '',
    owner: values.owner,
    entity: values.entity,
    factTable: values.factTable,
    typeSpec: values.typeSpec,
    filter: values.filter ?? undefined,
    nullHandling: values.nullHandling,
    labels: values.labels,
  };
}
